export const EVENTS_URL_PART = 'events'
